import "../config";
import axios from "axios";
var apiUrl = global.platformURI;

export const fetchAllSurveyQuestions = () => {
    return {
        type: 'FETCH_SURVEY_QUESTIONS',
        method: 'get',
        URLEndPoint: 'FETCH_SURVEY_QUESTIONS',
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const fetchEntrepreneurialSurveyQuestions = () => {
    return {
        type: 'FETCH_ENTREPRENEURIAL_SURVEY_QUESTIONS',
        method: 'get',
        URLEndPoint: 'FETCH_ENTREPRENEURIAL_SURVEY_QUESTIONS',
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const fetchEntrepreneurialUserByEmail = (params) => {
    return {
        type: 'FETCH_ENTREPRENEURIAL_USER_BY_EMAIL',
        method: 'get',
        params,
        URLEndPoint: 'FETCH_ENTREPRENEURIAL_USER_BY_EMAIL',
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const fetchEntrepreneurialReport = (params) => {
    return {
        type: 'FETCH_ENTREPRENEURIAL_REPORT',
        method: 'get',
        params,
        URLEndPoint: 'FETCH_ENTREPRENEURIAL_REPORT',
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const fetchAdminEntrepreneurialReport = (params) => {
    return {
        type: 'FETCH_ADMIN_ENTREPRENEURIAL_REPORT',
        method: 'get',
        params,
        URLEndPoint: 'FETCH_ADMIN_ENTREPRENEURIAL_REPORT',
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

// /entrepreneurial/save_answer

export const saveSurveyAnswer = (data) => {
    return {
        type: 'SAVE_ENTREPRENEURIAL_QUESTIONS_ANSWER',
        method: 'post',
        data,
        URLEndPoint: 'SAVE_ENTREPRENEURIAL_QUESTIONS_ANSWER',
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const deleteSurveyAnswer = (data) => {
    return {
        type: 'DELETE_ENTREPRENEURIAL_QUESTIONS_ANSWER',
        method: 'post',
        data,
        url: "/api/v1/entrepreneurial/delete_all_answers",
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}


export const fetchAllDemographicsQuestions = async () => {
    try {
        let data = await axios.get(apiUrl + `/api/v1/survey_questions/demographic_questions`)
        return {
            data: data?.data,
            status: data?.status
        }
    }
    catch (error) {
        return {
            message: 'somthing went wrong.',
            status: 500,
            error: error
        }
    }
}



export const submitDemographicsQuestions = (payload, isfinalQuestion) => {
    return {
        type: 'SUBMIT_SURVEY_QUESTIONS',
        method: 'post',
        URLEndPoint: 'SUBMIT_SURVEY_QUESTIONS',
        data: { survey_response: payload, final_ques: isfinalQuestion },
        axiosService: true,
        toaster: {
            loading: true
        }
    }
}

export const downloadSurveyReport = (userId) => {
    return apiUrl + `/api/v1/entrepreneurial/export_csv?user_id=${userId}`
}

export const processCreditCardPayment = (data) => {
    return {
        type: 'CREDIT_CARD_PAYMENT',
        method: 'post',
        data,
        URLEndPoint: 'CREDIT_CARD_PAYMENT',
        axiosService: true,
        toaster: {
            loading: true,
            success: "Payment processed successfully!",
            error: true
        }
    }
}

export const redeemAccessCode = (data) => {
    return {
        type: 'REDEEM_ACCESS_CODE',
        method: 'post',
        data,
        URLEndPoint: 'REDEEM_ACCESS_CODE',
        axiosService: true,
        toaster: {
            loading: true,
            success: "Access code redeemed successfully!",
            error: true
        }
    }
}